// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../src/img/ajax-loader.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main CSS */

:root {
    --bs-warning-text-emphasis: #b98b00;
}

body {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol";
    /* Better font rendering, especially for CodeMirror, it makes the font much brighter */
    -webkit-font-smoothing: subpixel-antialiased;
}

::-webkit-scrollbar {
    width: 0;
}

::-webkit-scrollbar-track {
    background: none;
}

::-webkit-scrollbar-thumb {
    background: none;
}

.no-transition {
    -webkit-transition: none !important;
    -moz-transition: none !important;
    -o-transition: none !important;
    transition: none !important;
}

nav.bg-body-secondary .btn-light:not(:hover),
nav.bg-body-tertiary .btn-light:not(:hover),
nav.bg-body-secondary .btn-dark:not(:hover),
nav.bg-body-tertiary .btn-dark:not(:hover) {
    background-color: transparent;
    border-color: transparent;
}

header.bg-body-tertiary .btn-light:not(:hover),
header.bg-body-tertiary .btn-dark:not(:hover) {
    background-color: transparent;
    border-color: transparent;
}

/* ajax-spinner */

.ajax-spinner {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.ajax-spinner-icon {
    display: inline-block;
    width: 32px;
    height: 32px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
    background-size: contain;
}

/* 3rd party */

.cke_combopanel {
    width: 200px !important;
}

.cke_combopanel__styles {
    width: 150px !important;
}

.CodeMirror {
    /* Uses Github's code font-family */
    font-family: SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace;
    font-size: 12px;
    white-space: pre;
}

/* Drag and drop */

/* Prevent the text contents of draggable elements from being selectable. */
[draggable] {
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    /* Required to make elements draggable in old WebKit */
    -khtml-user-drag: element;
    -webkit-user-drag: element;
}

[draggable].dragstart {
    background: blue;
}

[draggable].dragstart a {
    color: #fff;
}

/* Overlay */

.overlay {
    position: fixed;
    z-index: 10000; /* Raised from 100 to above 1000 to be higher than Bootstrap's dropdown menus */
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .8);
    color: #fff;
}

.overlay p > a {
    color: #fff;
}

.form-label .tooltip-inner {
    font-weight: normal;
    text-align: left;
    min-width: 200px;
}

[disabled].list-group-item {
    opacity: .7;
}

[disabled].list-group-item:hover {
    background: none;
    cursor: default;
}

/************************************************** Content layout tab & options **************************************************/

[data-name="layout"].tabs-tab .tabs-tab-link {
    background: no-repeat center center;
    text-indent: -999px;
}

.n-layout .list-group-item-heading {
    line-height: 30px;
}

/************************************************** Select list modal **************************************************/

[select-list-modal] .icon-btn {
    color: #000;
    border-radius: 5px;
}

[select-list-modal] .icon-btn:not(.disabled):hover {
    color: #000;
    background: #ccc;
    cursor: pointer;
}

/************************************************** COMPONENTS **************************************************/

#m_products_products__edit .n-shipping [type="checkbox"],
#product_types__edit .n-shipping [type="checkbox"] {
    float: left;
    margin: 11px 10px 0 0;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

.visible-on-hover-hidden {
    visibility: hidden;
}

.visible-on-hover:hover .visible-on-hover-hidden {
    visibility: visible;
}

input[size] {
    width: auto;
}

.text-decoration {
    text-decoration-color: #ccc;
    text-underline-offset: 3px;
}

.text-decoration:hover {
    text-decoration: none;
}

.btn-transparent:disabled,
.btn-transparent {
    background-color: transparent;
    border-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/css/main.css"],"names":[],"mappings":"AAAA,aAAa;;AAEb;IACI,mCAAmC;AACvC;;AAEA;IACI;uCACmC;IACnC,sFAAsF;IACtF,4CAA4C;AAChD;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,gCAAgC;IAChC,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;;;;IAII,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;;IAEI,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA,iBAAiB;;AAEjB;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,6DAA0D;IAC1D,wBAAwB;AAC5B;;AAEA,cAAc;;AAEd;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mCAAmC;IACnC,wEAAwE;IACxE,eAAe;IACf,gBAAgB;AACpB;;AAEA,kBAAkB;;AAElB,2EAA2E;AAC3E;IACI,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;IACzB,iBAAiB;IACjB,sDAAsD;IACtD,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA,YAAY;;AAEZ;IACI,eAAe;IACf,cAAc,EAAE,+EAA+E;IAC/F,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA,mIAAmI;;AAEnI;IACI,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,wHAAwH;;AAExH;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA,iHAAiH;;AAEjH;;IAEI,WAAW;IACX,qBAAqB;AACzB;;AAEA;;IAEI,8CAA8C;IAC9C,wBAAwB;IACxB,SAAS,EAAE,uEAAuE;AACtF;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,6BAA6B;IAC7B,yBAAyB;AAC7B","sourcesContent":["/* Main CSS */\n\n:root {\n    --bs-warning-text-emphasis: #b98b00;\n}\n\nbody {\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\",\n    \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n    /* Better font rendering, especially for CodeMirror, it makes the font much brighter */\n    -webkit-font-smoothing: subpixel-antialiased;\n}\n\n::-webkit-scrollbar {\n    width: 0;\n}\n\n::-webkit-scrollbar-track {\n    background: none;\n}\n\n::-webkit-scrollbar-thumb {\n    background: none;\n}\n\n.no-transition {\n    -webkit-transition: none !important;\n    -moz-transition: none !important;\n    -o-transition: none !important;\n    transition: none !important;\n}\n\nnav.bg-body-secondary .btn-light:not(:hover),\nnav.bg-body-tertiary .btn-light:not(:hover),\nnav.bg-body-secondary .btn-dark:not(:hover),\nnav.bg-body-tertiary .btn-dark:not(:hover) {\n    background-color: transparent;\n    border-color: transparent;\n}\n\nheader.bg-body-tertiary .btn-light:not(:hover),\nheader.bg-body-tertiary .btn-dark:not(:hover) {\n    background-color: transparent;\n    border-color: transparent;\n}\n\n/* ajax-spinner */\n\n.ajax-spinner {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n}\n\n.ajax-spinner-icon {\n    display: inline-block;\n    width: 32px;\n    height: 32px;\n    background: url('../../src/img/ajax-loader.gif') no-repeat;\n    background-size: contain;\n}\n\n/* 3rd party */\n\n.cke_combopanel {\n    width: 200px !important;\n}\n\n.cke_combopanel__styles {\n    width: 150px !important;\n}\n\n.CodeMirror {\n    /* Uses Github's code font-family */\n    font-family: SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace;\n    font-size: 12px;\n    white-space: pre;\n}\n\n/* Drag and drop */\n\n/* Prevent the text contents of draggable elements from being selectable. */\n[draggable] {\n    -moz-user-select: none;\n    -khtml-user-select: none;\n    -webkit-user-select: none;\n    user-select: none;\n    /* Required to make elements draggable in old WebKit */\n    -khtml-user-drag: element;\n    -webkit-user-drag: element;\n}\n\n[draggable].dragstart {\n    background: blue;\n}\n\n[draggable].dragstart a {\n    color: #fff;\n}\n\n/* Overlay */\n\n.overlay {\n    position: fixed;\n    z-index: 10000; /* Raised from 100 to above 1000 to be higher than Bootstrap's dropdown menus */\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, .8);\n    color: #fff;\n}\n\n.overlay p > a {\n    color: #fff;\n}\n\n.form-label .tooltip-inner {\n    font-weight: normal;\n    text-align: left;\n    min-width: 200px;\n}\n\n[disabled].list-group-item {\n    opacity: .7;\n}\n\n[disabled].list-group-item:hover {\n    background: none;\n    cursor: default;\n}\n\n/************************************************** Content layout tab & options **************************************************/\n\n[data-name=\"layout\"].tabs-tab .tabs-tab-link {\n    background: no-repeat center center;\n    text-indent: -999px;\n}\n\n.n-layout .list-group-item-heading {\n    line-height: 30px;\n}\n\n/************************************************** Select list modal **************************************************/\n\n[select-list-modal] .icon-btn {\n    color: #000;\n    border-radius: 5px;\n}\n\n[select-list-modal] .icon-btn:not(.disabled):hover {\n    color: #000;\n    background: #ccc;\n    cursor: pointer;\n}\n\n/************************************************** COMPONENTS **************************************************/\n\n#m_products_products__edit .n-shipping [type=\"checkbox\"],\n#product_types__edit .n-shipping [type=\"checkbox\"] {\n    float: left;\n    margin: 11px 10px 0 0;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    /* display: none; <- Crashes Chrome on hover */\n    -webkit-appearance: none;\n    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */\n}\n\n.visible-on-hover-hidden {\n    visibility: hidden;\n}\n\n.visible-on-hover:hover .visible-on-hover-hidden {\n    visibility: visible;\n}\n\ninput[size] {\n    width: auto;\n}\n\n.text-decoration {\n    text-decoration-color: #ccc;\n    text-underline-offset: 3px;\n}\n\n.text-decoration:hover {\n    text-decoration: none;\n}\n\n.btn-transparent:disabled,\n.btn-transparent {\n    background-color: transparent;\n    border-color: transparent;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
